import { HttpClient } from 'api/http-client';
import { Field } from 'api/tasks';

export interface ProjectFields {
  projects: Array<{ fields: Field[] }>;
  fields: Field[];
}

class ProjectFieldsHttpClient extends HttpClient {
  public async getProjectFields(): Promise<ProjectFields> {
    return this.get<ProjectFields>('/projects/fields');
  }
}

export const ProjectFieldsAPI = new ProjectFieldsHttpClient();
